
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/cfs",
      function () {
        return require("private-next-pages/ir/financial/cfs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/financial/cfs"])
      });
    }
  